export const INACTIVITY_TIMEOUT_MINUTES = 5;
export const LOGOUT_DELAY_MINUTES = 2;
